// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --body-bg-color: #f1f5ff;
  --primary-color: #1b5bff;
  --seconadry-color: #a370ce;
  --seconadry-ic-bg: #eeebff;
  --pirmary-ic-bg: #dae4fe;
  --dark-heading-text: #1e1e1e;
  --light-heading-text: #4d4d4d;
  --text-color: #6b6b6b;
  --white-color: #fff;
  --gradient-color: linear-gradient(to bottom, #a370ce, #103799);
}

body {
  background: var(--body-bg-color);
} */

.NewLogin_wrapper__7C0zd {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.NewLogin_loginContainer__ZRibj {
  flex: 1 1;
  display: inline-block;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 8rem;
  /* border: 1px solid white; */
}
.NewLogin_loginContent__Ipjoa {
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.NewLogin_loginContainer__ZRibj img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: -1;
}

.NewLogin_login_left__DJixI {
  width: 50%;
  position: relative;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-right: 30px;
  text-align: center;
}
.NewLogin_login_left__DJixI h1 {
  font-size: 80px;
  /* text-align: center; */
}
.NewLogin_login_left__DJixI p {
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.5px;
  padding: 10px 0px;
}

.NewLogin_login__LQuOi {
  width: 50%;
  max-height: 700px;
  max-width: 600px;
  background-color: aliceblue;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 12px;
  padding: 50px 30px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
.NewLogin_login__LQuOi h3 {
  text-align: center;
  font-size: 24px;
  color: var(--dark-heading-text);
}
.NewLogin_login__LQuOi::-webkit-scrollbar {
  width: 0; /* Hide scrollbar for Chrome, Safari, and Opera */
}
/* .loginForm {
  padding: 20px 0px 0px 0px;
} */

.NewLogin_formGroup__Gngu5 {
  margin-bottom: 24px;
  position: relative;
}
.NewLogin_formGroup__Gngu5 label {
  display: block;
  /* margin-bottom: 10px; */
  font-size: 15px;
  font-weight: 500;
  color: #555;
}
.NewLogin_inputWrapper__NPJrA {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.NewLogin_userType__58ssz {
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 20px;
}
.NewLogin_userType__58ssz label {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: var(--seconadry-ic-bg);
  padding: 10px;
  border-radius: 4px;
}
.NewLogin_inputWrapper__NPJrA input {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  border: none;
  background: var(--seconadry-ic-bg);
  border-radius: 8px;
  color: var(--text-color);
  padding-right: 50px;
  outline: none;
}
.NewLogin_inputWrapper__NPJrA ::placeholder {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color);
}
.NewLogin_inputWrapper__NPJrA input:focus {
  border: 1px solid var(--seconadry-color);
  color: var(--dark-heading-text);
}
.NewLogin_inputWrapper__NPJrA input:active {
  border: 1px solid var(--seconadry-color);
  color: var(--dark-heading-text);
}
.NewLogin_inputIcon__6bqvv {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-color);
  font-size: 24px;
}

.NewLogin_password-toggle-button__-Fsi\\+ {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
}

.NewLogin_forgotPassword__IXuss {
  display: flex;
  justify-content: flex-end;
  /* margin-bottom: 15px; */
}

.NewLogin_forgotPassword__IXuss a {
  text-decoration: none;
  color: var(--seconadry-color);
  font-size: 16px;
  font-weight: 600;
}

.NewLogin_forgotPassword__IXuss a:hover {
  text-decoration: underline;
}
.NewLogin_signupLink__j9e2J {
  display: flex;
  justify-content: center;
  /* margin-top: 30px; */
  margin-top: 20px;
  gap: 5px;
}
.NewLogin_signupLink__j9e2J a {
  text-decoration: none;
  color: var(--seconadry-color);
  font-size: 16px;
  font-weight: 600;
}
.NewLogin_signupLink__j9e2J a:hover {
  text-decoration: underline;
}
.NewLogin_button__u6LE7 {
  width: 100%;
  height: 58px;
  margin-top: 36px;
  background-color: var(--primary);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.NewLogin_button__u6LE7:hover {
  background-color: none;
}

.NewLogin_contactBtn__MM5C2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 100px;
}

.NewLogin_errorPopup__LdJq7 {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: baseline;

  z-index: 1000;
}

.NewLogin_errorPopupContent__IWhzK {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  margin: auto;
  position: relative;
}
.NewLogin_ellipsisText__2TBb5 {
  width: 250px; /* Set any fixed width */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.NewLogin_errorPopupContent__IWhzK h4 {
  margin: 0 0 10px;
}

.NewLogin_errorPopupContent__IWhzK p {
  margin: 0 0 20px;
}

.NewLogin_close__VtP\\+7 {
  background-color: #d8d8d8;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  right: -15px;
  top: -15px;
  border-radius: 50%;
  font-size: 20px;
  width: 30px;
  height: 30px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Mobile styles */

@media (min-width: 769px) and (max-width: 1024px) {
  .NewLogin_loginContainer__ZRibj {
    padding: 4rem 8rem;
  }
  .NewLogin_loginContent__Ipjoa {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px;
  }
  .NewLogin_login_left__DJixI {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 30px;
  }
  .NewLogin_login_left__DJixI h1 {
    font-size: 50px;
  }
  .NewLogin_login__LQuOi p {
    font-size: 18px;
  }
  .NewLogin_signup__Iq4An {
    width: 100%;
  }
    .NewLogin_inputIcon__6bqvv {
    font-size: 20px;
  }
}

@media (min-width: 369px) and (max-width: 768px) {
  .NewLogin_loginContainer__ZRibj {
    padding: 4rem;
  }
  .NewLogin_loginContent__Ipjoa {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px;
  }
  .NewLogin_login_left__DJixI {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 30px;
  }
  .NewLogin_login_left__DJixI h1 {
    font-size: 50px;
  }
  .NewLogin_login__LQuOi p {
    font-size: 18px;
  }
  .NewLogin_login__LQuOi {
    width: 100%;
  }
    .NewLogin_inputIcon__6bqvv {
    font-size: 20px;
  }
}

@media screen and (max-width: 368px) {
  .NewLogin_wrapper__7C0zd {
    width: 100%;
  }
  .NewLogin_navbar__IQxpR {
    position: fixed;
    z-index: 1;
    width: 100%;
  }
  .NewLogin_loginContainer__ZRibj {
    padding: 0;
    height: 80vh;
    margin-top: 20px;
  }
  .NewLogin_loginContainer__ZRibj img {
    display: none;
  }
  .NewLogin_loginContant__YZ61P {
    padding: 0px;
    flex-direction: column;
    height: auto;
  }
  .NewLogin_login_left__DJixI {
    width: 100%;
    margin-bottom: 40px;
    display: none;
  }
  .NewLogin_login__LQuOi {
    width: 100%;
    padding: 16px 0px;
    margin: 0px;
    box-shadow: none;
  }
  .NewLogin_contactBtn__MM5C2 {
    display: none;
  }
  .NewLogin_loginContainer__ZRibj img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 80vh;
    object-fit: fill;
    z-index: -1;
  }
  .NewLogin_loginContent__Ipjoa {
    padding: 0px 20px;
  }
  .NewLogin_inputIcon__6bqvv {
    font-size: 20px;
  }
  .NewLogin_button__u6LE7 {
    margin-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Auth/New Login/NewLogin.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,QAAQ,EAAE,iDAAiD;AAC7D;AACA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;AACA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,qBAAqB;;EAErB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY,EAAE,wBAAwB;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,kBAAkB;;AAElB;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;IACE;IACA,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;IACE;IACA,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --body-bg-color: #f1f5ff;\n  --primary-color: #1b5bff;\n  --seconadry-color: #a370ce;\n  --seconadry-ic-bg: #eeebff;\n  --pirmary-ic-bg: #dae4fe;\n  --dark-heading-text: #1e1e1e;\n  --light-heading-text: #4d4d4d;\n  --text-color: #6b6b6b;\n  --white-color: #fff;\n  --gradient-color: linear-gradient(to bottom, #a370ce, #103799);\n}\n\nbody {\n  background: var(--body-bg-color);\n} */\n\n.wrapper {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n.loginContainer {\n  flex: 1;\n  display: inline-block;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  padding: 8rem;\n  /* border: 1px solid white; */\n}\n.loginContent {\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.loginContainer img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  z-index: -1;\n}\n\n.login_left {\n  width: 50%;\n  position: relative;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin-right: 30px;\n  text-align: center;\n}\n.login_left h1 {\n  font-size: 80px;\n  /* text-align: center; */\n}\n.login_left p {\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 1.5px;\n  padding: 10px 0px;\n}\n\n.login {\n  width: 50%;\n  max-height: 700px;\n  max-width: 600px;\n  background-color: aliceblue;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border-radius: 12px;\n  padding: 50px 30px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n}\n.login h3 {\n  text-align: center;\n  font-size: 24px;\n  color: var(--dark-heading-text);\n}\n.login::-webkit-scrollbar {\n  width: 0; /* Hide scrollbar for Chrome, Safari, and Opera */\n}\n/* .loginForm {\n  padding: 20px 0px 0px 0px;\n} */\n\n.formGroup {\n  margin-bottom: 24px;\n  position: relative;\n}\n.formGroup label {\n  display: block;\n  /* margin-bottom: 10px; */\n  font-size: 15px;\n  font-weight: 500;\n  color: #555;\n}\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n.userType {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  gap: 20px;\n}\n.userType label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background-color: var(--seconadry-ic-bg);\n  padding: 10px;\n  border-radius: 4px;\n}\n.inputWrapper input {\n  width: 100%;\n  padding: 16px;\n  font-weight: 600;\n  border: none;\n  background: var(--seconadry-ic-bg);\n  border-radius: 8px;\n  color: var(--text-color);\n  padding-right: 50px;\n  outline: none;\n}\n.inputWrapper ::placeholder {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--text-color);\n}\n.inputWrapper input:focus {\n  border: 1px solid var(--seconadry-color);\n  color: var(--dark-heading-text);\n}\n.inputWrapper input:active {\n  border: 1px solid var(--seconadry-color);\n  color: var(--dark-heading-text);\n}\n.inputIcon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-color);\n  font-size: 24px;\n}\n\n.password-toggle-button {\n  position: absolute;\n  right: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  color: #555;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.forgotPassword {\n  display: flex;\n  justify-content: flex-end;\n  /* margin-bottom: 15px; */\n}\n\n.forgotPassword a {\n  text-decoration: none;\n  color: var(--seconadry-color);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.forgotPassword a:hover {\n  text-decoration: underline;\n}\n.signupLink {\n  display: flex;\n  justify-content: center;\n  /* margin-top: 30px; */\n  margin-top: 20px;\n  gap: 5px;\n}\n.signupLink a {\n  text-decoration: none;\n  color: var(--seconadry-color);\n  font-size: 16px;\n  font-weight: 600;\n}\n.signupLink a:hover {\n  text-decoration: underline;\n}\n.button {\n  width: 100%;\n  height: 58px;\n  margin-top: 36px;\n  background-color: var(--primary);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.button:hover {\n  background-color: none;\n}\n\n.contactBtn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 100px;\n}\n\n.errorPopup {\n  position: fixed;\n  top: 0px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n\n  z-index: 1000;\n}\n\n.errorPopupContent {\n  background: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  max-width: 400px;\n  margin: auto;\n  position: relative;\n}\n.ellipsisText {\n  width: 250px; /* Set any fixed width */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.errorPopupContent h4 {\n  margin: 0 0 10px;\n}\n\n.errorPopupContent p {\n  margin: 0 0 20px;\n}\n\n.close {\n  background-color: #d8d8d8;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  position: absolute;\n  right: -15px;\n  top: -15px;\n  border-radius: 50%;\n  font-size: 20px;\n  width: 30px;\n  height: 30px;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n  color: #333333;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/* Mobile styles */\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .loginContainer {\n    padding: 4rem 8rem;\n  }\n  .loginContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 0px;\n  }\n  .login_left {\n    width: 100%;\n    margin-right: 0px;\n    margin-bottom: 30px;\n  }\n  .login_left h1 {\n    font-size: 50px;\n  }\n  .login p {\n    font-size: 18px;\n  }\n  .signup {\n    width: 100%;\n  }\n    .inputIcon {\n    font-size: 20px;\n  }\n}\n\n@media (min-width: 369px) and (max-width: 768px) {\n  .loginContainer {\n    padding: 4rem;\n  }\n  .loginContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 0px;\n  }\n  .login_left {\n    width: 100%;\n    margin-right: 0px;\n    margin-bottom: 30px;\n  }\n  .login_left h1 {\n    font-size: 50px;\n  }\n  .login p {\n    font-size: 18px;\n  }\n  .login {\n    width: 100%;\n  }\n    .inputIcon {\n    font-size: 20px;\n  }\n}\n\n@media screen and (max-width: 368px) {\n  .wrapper {\n    width: 100%;\n  }\n  .navbar {\n    position: fixed;\n    z-index: 1;\n    width: 100%;\n  }\n  .loginContainer {\n    padding: 0;\n    height: 80vh;\n    margin-top: 20px;\n  }\n  .loginContainer img {\n    display: none;\n  }\n  .loginContant {\n    padding: 0px;\n    flex-direction: column;\n    height: auto;\n  }\n  .login_left {\n    width: 100%;\n    margin-bottom: 40px;\n    display: none;\n  }\n  .login {\n    width: 100%;\n    padding: 16px 0px;\n    margin: 0px;\n    box-shadow: none;\n  }\n  .contactBtn {\n    display: none;\n  }\n  .loginContainer img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 80vh;\n    object-fit: fill;\n    z-index: -1;\n  }\n  .loginContent {\n    padding: 0px 20px;\n  }\n  .inputIcon {\n    font-size: 20px;\n  }\n  .button {\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `NewLogin_wrapper__7C0zd`,
	"loginContainer": `NewLogin_loginContainer__ZRibj`,
	"loginContent": `NewLogin_loginContent__Ipjoa`,
	"login_left": `NewLogin_login_left__DJixI`,
	"login": `NewLogin_login__LQuOi`,
	"formGroup": `NewLogin_formGroup__Gngu5`,
	"inputWrapper": `NewLogin_inputWrapper__NPJrA`,
	"userType": `NewLogin_userType__58ssz`,
	"inputIcon": `NewLogin_inputIcon__6bqvv`,
	"password-toggle-button": `NewLogin_password-toggle-button__-Fsi+`,
	"forgotPassword": `NewLogin_forgotPassword__IXuss`,
	"signupLink": `NewLogin_signupLink__j9e2J`,
	"button": `NewLogin_button__u6LE7`,
	"contactBtn": `NewLogin_contactBtn__MM5C2`,
	"errorPopup": `NewLogin_errorPopup__LdJq7`,
	"errorPopupContent": `NewLogin_errorPopupContent__IWhzK`,
	"ellipsisText": `NewLogin_ellipsisText__2TBb5`,
	"close": `NewLogin_close__VtP+7`,
	"signup": `NewLogin_signup__Iq4An`,
	"navbar": `NewLogin_navbar__IQxpR`,
	"loginContant": `NewLogin_loginContant__YZ61P`
};
export default ___CSS_LOADER_EXPORT___;
